import { createFileRoute } from '@tanstack/react-router';

import { ErrorComponent } from '@/components/common/ErrorComponent';
import { useSetBreadcrumbs } from '@/components/layout/breadcrumbs';

import { CustomFieldsPage } from './-components/CustomFieldsPage';

function CustomFieldsRoute() {
  useSetBreadcrumbs([{ label: 'Settings' }, { label: 'Custom fields' }]);
  return <CustomFieldsPage />;
}

export const Route = createFileRoute('/settings/custom-fields')({
  component: CustomFieldsRoute,
  errorComponent: ErrorComponent,
});
